import { render, staticRenderFns } from "./MetagProject.vue?vue&type=template&id=54e75824&scoped=true"
import script from "./MetagProject.vue?vue&type=script&lang=js"
export * from "./MetagProject.vue?vue&type=script&lang=js"
import style0 from "./MetagProject.vue?vue&type=style&index=0&id=54e75824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e75824",
  null
  
)

export default component.exports